<template>
  <ts-loading-banner :loading="loading">
    <div class="ts-grid ts-grid-cols-3 ts-gap-6">
      <div class="ts-w-full">
        <label class="required ts-font-robot">{{
          $t('projectProfile.name')
        }}</label>
      </div>
      <div class="ts-col-span-2">
        <input
          v-model="model.milestone_name"
          type="text"
          class="form-control"
          placeholder="Input milestone name. ex: Develop"
        />
        <div class="validate" v-if="errors.has('milestone_name')">
          {{ errors.first('milestone_name') }}
        </div>
      </div>
      <div class="ts-w-full">
        <label class="required ts-font-robot">{{
          $t('projectProfile.status')
        }}</label>
      </div>
      <div class="ts-col-span-2">
        <a-select
          v-model="model.status_id"
          :options="projectStatus"
          show-search
          option-filter-prop="children"
          :filter-option="filterOption"
          class="ts-w-full"
          placeholder="Select who is main response"
        ></a-select>
        <div class="validate" v-if="errors.has('status_id')">
          {{ errors.first('status_id') }}
        </div>
      </div>
      <div class="ts-w-full">
        <label class="ts-font-robot">{{ $t('projectProfile.owner') }}</label>
      </div>
      <div class="ts-col-span-2">
        <a-select
          v-model="model.milestone_owner"
          :options="owners"
          show-search
          option-filter-prop="children"
          :filter-option="filterOption"
          class="ts-w-full"
          placeholder="Select who is main response"
        ></a-select>
        <div class="validate" v-if="errors.has('milestone_owner')">
          {{ errors.first('milestone_owner') }}
        </div>
      </div>
      <div class="ts-w-full">
        <label class="ts-font-robot">{{
          $t('projectProfile.estimated')
        }}</label>
      </div>
      <div class="ts-col-span-2">
        <a-range-picker
          v-model="model.estimated_date"
          format="DD-MM-YYYY"
          valueFormat="DD-MM-YYYY"
          class="ts-w-full"
        />
        <div class="validate" v-if="errors.has('estimated_date')">
          {{ errors.first('estimated_date') }}
        </div>
      </div>
      <div class="ts-w-full">
        <label class="ts-font-robot ts-capitalize">{{
          $t('projectProfile.actual')
        }}</label>
      </div>
      <div class="ts-col-span-2">
        <a-range-picker
          v-model="model.actual_date"
          format="DD-MM-YYYY"
          valueFormat="DD-MM-YYYY"
          class="ts-w-full"
        />
        <div class="validate" v-if="errors.has('actual_date')">
          {{ errors.first('actual_date') }}
        </div>
      </div>
      <div class="ts-w-full ts-col-span-3">
        <Attachment v-model="attachment" />
      </div>
      <div class="ts-w-full ts-col-span-3">
        <div class="ts-pl-3 ts-mt-3">
          <ul>
            <li v-for="(att, index) in edit_data.attachments" :key="index">
              <button
                class="ts-mr-2 hover:ts-text-red-600"
                @click.prevent="deleteRecord(att.id)"
              >
                <Icon type="ios-trash-outline" size="18" />
              </button>
              <a href="#" @click.prevent="onClickViewFile(att)">{{
                att.file_name
              }}</a>
              creaed by <b>{{ att.name }}</b>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="row ts-mt-4">
      <div
        class="col-md-12 ts-flex ts-items-center ts-justify-end ts-space-x-3"
      >
        <ts-button @click.prevent="$emit('close')">
          {{ $t('cancel') }}</ts-button
        >
        <ts-button color="primary" @click.prevent="onUpdate">
          {{ $t('update') }}</ts-button
        >
      </div>
    </div>
  </ts-loading-banner>
</template>

<script>
import { debounce } from 'lodash'
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'
import Attachment from './attach-file.vue'

export default {
  props: ['edit_data'],
  components: {
    Attachment
  },
  data() {
    return {
      errors: new Errors(),
      owners: [],
      projectStatus: [],
      loading: false,
      model: {
        project_id: '',
        milestone_name: '',
        milestone_owner: '',
        milestone_member: [],
        estimated_date: undefined,
        actual_date: undefined,
        status_id: 1
      },
      attachment: {
        files: []
      }
    }
  },
  created() {
    this.fetchViewModel()
  },
  methods: {
    ...mapActions('projectMgt/projectMilestone', [
      'formViewModel',
      'update',
      'attachFile',
      'deleteAttachment'
    ]),
    fetchViewModel: debounce(function() {
      this.loading = true
      this.formViewModel({
        fnName: 'owner,status',
        project_id: this.edit_data.project_id
      })
        .then(response => {
          this.owners = response.data.owner.map(el => ({
            value: el.user_id,
            label: el.employee_name_kh + '|' + el.employee_name_en
          }))
          this.projectStatus = response.data.status.map(el => ({
            value: el.status_id,
            label: el.project_status
          }))
          this.onEditData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => (this.loading = false))
    }, 500),
    onUpdate() {
      this.loading = true
      this.errors = new Errors()
      this.update({
        id: this.edit_data.milestone_id,
        data: this.model
      })
        .then(response => this.onAttchmentFile().then(() => response))
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('close', false)
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onEditData() {
      this.model.project_id = this.edit_data.project_id
      this.model.milestone_id = this.edit_data.milestone_id
      this.model.milestone_name = this.edit_data.milestone_name
      this.model.milestone_owner = this.edit_data.milestone_owner
      if (
        this.edit_data.estimated_start_date &&
        this.edit_data.estimated_end_date
      ) {
        this.model.estimated_date = [
          this.edit_data.estimated_start_date,
          this.edit_data.estimated_end_date
        ]
      }
      if (this.edit_data.actual_start_date && this.edit_data.actual_end_date) {
        this.model.actual_date = [
          this.edit_data.actual_start_date,
          this.edit_data.actual_end_date
        ]
      }

      this.model.status_id = this.edit_data.status_id
      this.model.milestone_member = JSON.parse(
        this.edit_data.milestone_member
      ).map(el => el.user_id)
    },
    onClose() {
      this.$emit('close', false)
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    },
    async onAttchmentFile() {
      if (this.attachment.files.length) {
        let formData = new FormData()
        formData.append('model_id', this.model.milestone_id)
        formData.append('model_type', 'milestone')
        for (var i = 0; i < this.attachment.files.length; i++) {
          let file = this.attachment.files[i]
          formData.append('files[' + i + ']', file)
        }
        await this.attachFile(formData)
        this.attachment.files = []
      }

      return new Promise(r => r('done'))
    },
    onClickViewFile(att) {
      window.open(att.file_path, '_blank', 'noreferrer')
    },
    deleteRecord(id) {
      this.$confirm({
        title: this.$t('task.are_you_want_to_delete_it_cant_redo'),
        okText: this.$t('yes'),
        okType: 'danger',
        cancelText: this.$t('no'),
        centered: true,
        onOk: () => {
          return this.deleteAttachment(id)
            .then(response => {
              this.$emit('fetch')
              return Promise.resolve(response)
            })
            .catch(error => {
              this.$toasted.error(error.message)
              return Promise.reject(error)
            })
        },
        onCancel() {}
      })
    }
  }
}
</script>
